export default __webpack_public_path__ + "static/media/tarima11.66580e76.png";